import { Dispatch, FC, SetStateAction } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import cn from 'classnames';
import { SectionHeader, EmptyState } from '@ets/design-system';

import in_ from '_common/utils/in';
import { AUTOMATION_TRIGGER_TRANSLATIONS } from 'Settings/pages/TenantSettingsPage/Metadata/const';

import Table from './Table';
import styles from '../Metadata.module.scss';

type AutomaticMetadataProps = {
  metadata: ApiSchemas['MetadataObjectSchema'][];
  selected: number;
  select: Dispatch<SetStateAction<number>>;
  deleteMetadata: (id: string, name: string) => void;
};

const AutomaticMetadata: FC<AutomaticMetadataProps> = ({
  metadata,
  selected,
  select,
  deleteMetadata,
}) => {
  const intl = useIntl();
  const selectedMetadata = metadata[selected];

  return (
    <div className={styles.section}>
      {metadata.length === 0 ? (
        <EmptyState
          size="m"
          testId="automatic-metadata"
          title={intl.formatMessage({ id: 'NO_METADATA_IN_TENANT_TITLE' })}
          description={intl.formatMessage({ id: 'NO_METADATA_IN_TENANT_BODY' })}
        />
      ) : (
        <>
          <div className={styles.table}>
            <Table
              metadata={metadata}
              selectedMetadata={selectedMetadata}
              deleteMetadata={deleteMetadata}
              select={select}
            />
          </div>
          {selectedMetadata && (
            <div className={styles.details}>
              <SectionHeader
                size="m"
                testId="automatic-metadata-details"
                primaryAction={{
                  type: 'button',
                  icon: 'xmark',
                  variant: 'link',
                  onClick: () => {
                    select(-1);
                  },
                }}
                style={{ margin: '0 0 1rem 0' }}
              >
                {selectedMetadata.name}
              </SectionHeader>
              <div className={styles.content}>
                <div className={styles.field} data-testid="automatic-name-field">
                  <FormattedMessage id="global.name" />
                  <div className={styles.value}>{selectedMetadata.name}</div>
                </div>
                <div className={styles.field} data-testid="automatic-trigger-field">
                  <FormattedMessage id="AUTOMATION_TRIGGER" />
                  <div className={styles.value}>
                    {/* @ts-expect-error Metadata specs issue - trigger not a proprerty */}
                    {in_(selectedMetadata.trigger, AUTOMATION_TRIGGER_TRANSLATIONS)
                      ? // @ts-expect-error Metadata specs issue - trigger not a proprerty
                        AUTOMATION_TRIGGER_TRANSLATIONS[selectedMetadata.trigger]
                      : // @ts-expect-error Metadata specs issue - trigger not a proprerty
                        selectedMetadata.trigger}
                  </div>
                </div>
                <div className={styles.field} data-testid="automatic-required-field">
                  <FormattedMessage id="REQUIRED" />
                  <div className={cn(styles.value, styles.capitalize)}>
                    {selectedMetadata.required.toString()}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AutomaticMetadata;
